import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { AddressTypeDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-address-type-tbl-container',
  templateUrl: './address-type-tbl-container.component.html',
  styleUrls: ['./address-type-tbl-container.component.scss']
})
export class AddressTypeTblContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  addresstypes$: Observable<AddressTypeDto[]>;
  loading: boolean;
  isLoadingAddressType$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingAddressType$ = this.gatwayFacade.isLoadingGateway('AddressTypeTbl');
    this.addresstypes$ = this.gatwayFacade.loadGateway('AddressTypeTbl');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteAddressType(deletedValue: any) {
    this.gatwayFacade.remove('AddressTypeTbl', deletedValue);
  }

  // this method control both the create and update

  onSubmitAddressType(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.AddressTypes;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllAddressType = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllAddressType.push(pullData[i]);
      }
    }

    // check if the addAllAddressType array is not empty, then dispatch the data to the store
    if (addAllAddressType.length > 0) {
      this.gatwayFacade.add('AddressTypeTbl', addAllAddressType);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('AddressTypeTbl', allUpdates, ['id']);
    }
  }
}
